import React from 'react';
import { AutoResizer } from 'react-base-table';
import { isEmpty } from 'lodash';
import { Retry } from '@components/common';
import ActionCell from './ActionCell';
import { formatDate, formatStatus, formatUsername } from './utils';
import { TableWrapper, StyledBaseTable } from './styled';
import useFetchSchedules from '@src/pages/Precision/hooks/useFetchSchedules';
import { policyAction } from '@src/store/policies/schedule/utils';

const getColumns = (refetch) => {
  return [
    {
      title: 'Policies',
      key: 'policyNames',
      dataKey: 'policyNames',
      width: 0,
      align: 'left',
      flexGrow: 1,
      sortable: true,
    },
    {
      title: 'Trigger At',
      key: 'triggerAt',
      dataKey: 'triggerAt',
      width: 200,
      align: 'left',
      dataGetter: formatDate,
      sortable: true,
    },
    {
      title: 'Notes',
      key: 'notes',
      dataKey: 'notes',
      width: 0,
      align: 'left',
      flexGrow: 1,
      sortable: true,
    },
    {
      title: 'Status',
      key: 'state',
      dataKey: 'state',
      dataGetter: formatStatus,
      width: 120,
      align: 'left',
      sortable: true,
    },
    {
      title: 'Last Updated',
      key: 'updatedAt',
      dataKey: 'updatedAt',
      width: 200,
      align: 'left',
      dataGetter: formatDate,
      sortable: true,
    },
    {
      title: 'Updated By',
      key: 'username',
      dataKey: 'username',
      width: 200,
      align: 'left',
      dataGetter: formatUsername,
      sortable: true,
    },
    {
      title: 'Actions',
      key: 'actions',
      width: 120,
      align: 'left',
      cellRenderer: ({ rowData }) => <ActionCell rowData={rowData} />,
    },
  ];
};

function Table({ canEdit, type = policyAction.activate }) {
  const {
    orderedRows = [],
    isFetching,
    isError,
    refetch,
    onColumnSort,
    sortBy,
  } = useFetchSchedules(type);

  const columns: any = getColumns(refetch);

  if (!canEdit) {
    columns.find((c) => c.key === 'actions').hidden = true;
  }

  const reorderColumns = columns.filter((column) => column.key !== 'policyNames');
  const displayColumns = type === policyAction.activate ? columns : reorderColumns;

  return (
    <TableWrapper>
      <Retry
        isLoading={isFetching}
        showError={isError}
        isEmpty={isEmpty(orderedRows)}
        mountChildAlways={false}
        fetchData={refetch}
      >
        <AutoResizer>
          {({ width, height }) => (
            <StyledBaseTable
              data={orderedRows}
              columns={displayColumns}
              headerHeight={30}
              rowHeight={45}
              fixed={false}
              width={width}
              height={height}
              sortBy={sortBy}
              onColumnSort={onColumnSort}
            />
          )}
        </AutoResizer>
      </Retry>
    </TableWrapper>
  );
}

export default Table;
